<div *ngIf="initialized" class="card">
  <!-- Header -->
  <header class="card-header bg-light py-3 px-5">
    <div class="d-flex justify-content-between align-items-center">
      <h3 class="h6 mb-0">Poster Feedback</h3>

      <button type="button" class="close" aria-label="Close" (click)="close()">
        <span aria-hidden="true">×</span>
      </button>
    </div>
  </header>
  <!-- End Header -->

  <!-- Body -->

  <div class="card-body" style="">
    <form [formGroup]="formGroup" (ngSubmit)="onSave()" novalidate>
      <div *ngIf="reviewSubmitted" class="alert alert-success text-center mt-2">Review Submitted</div>

      <div *ngIf="!reviewSubmitted" class="participant-list text-right" style="">
        <div>
          <textarea style="height: 300px;" formControlName="text" class="form-control"></textarea>
          <div class="invalid-message">Please enter a review</div>
        </div>

        <button type="submit" class="mr-2 mt-1 mb-1 btn btn-primary">Submit</button>
      </div>
    </form>
  </div>
</div>
